// extracted by mini-css-extract-plugin
export var present = "present-module--present--a447e";
export var videoBg = "present-module--video-bg--96f94";
export var videoBlock = "present-module--video-block--0d1c8";